export const NOT_AVAIBLE = 'Not yet available.';
export const CHECK_LATER = 'Please check back later!';
